import type { RouteObject } from 'react-router';

import { AboutPage } from './About';

/**
 * `/pages/about`.
 *
 * One `RouteObject`, so the file is `.route.tsx` **singular** — the feature is
 * the plural one, because it backs two routes. There is **no `/pages` landing
 * route**: the pack's sitemap carries neither, so the crumb is two levels and no
 * parent element sits between the console layout and this page.
 *
 * It sits inside the console layout route, which already runs the guard chain.
 * The route admits an `operator`; the write is re-checked by `backend-content`
 * on the request itself, and the console pre-computes no part of that outcome.
 */
export const aboutRoute: RouteObject = {
  path: 'pages/about',
  element: <AboutPage />,
};
